import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="0 0 12 14"
    xmlnsXlink="//www.w3.org/1999/xlink"
    width="1em"
    height="1em"
    {...props}
  >
    <defs>
      <path id="a" d="M.004.018h11.844v6.445H.004z" />
      <path id="c" d="M0 .018h4.969v6.68H0z" />
    </defs>
    <g fillRule="evenodd">
      <g transform="translate(0 .026)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M8.376.117C4.917.386-.525 2.191.046 5.303c.212 1.155 1.244 1.3 1.729 1.063-.337.088-.805-.455-.353-1.028 1.07-1.355 5.89-1.738 8.94-.918.492-2.802 1.486-4.392 1.486-4.392s-1.62-.054-3.472.09"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(0 6.253)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          d="M2.302.03c2.714-.273 4.667 4.522-.906 6.668C1.524 3.592-.024 2.181 0 2.071 2.436 2.935 3.432.756 2.302.029"
          mask="url(#d)"
        />
      </g>
      <path d="M4.978 11.503c.605.113 1.773.464 3.034 1.562.216-.177.506-.443.823-.808.215-.248-.178.432-.677.938.075.068.15.138.225.212.527-.405 1.888-1.803 1.976-3.577.118 1.154-.623 2.744-1.828 3.726.13.133.26.275.391.426 5.123-4.896-.099-11.319-6.306-8.276 3.83-.532 4.354 4.156 2.362 5.797" />
    </g>
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./src/asset/icon/wandu.svg